export const DATE_PERIOD_ELEMENTS = ['previous_month', 'current_year', 'previous_year']
